/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'

import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import {
  getWSAccessInfoWEE,
  saveWSAccessInfoWEE,
  deleteWSAccessInfoWEE,
} from 'api/pgads.js'
import CommonScreen from './../CommonScreen'
import { Input, Button } from 'antd'

import styled from 'styled-components'
const TableTD = styled.td`
  text-align: end;
`

const headers = [
  strCol({
    ident: 'serviceName',
    display: 'Service Name',
    isKey: true,
    width: 250,
  }),
  strCol({
    ident: 'url',
    display: 'Service URL',
    width: 600,
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'userName',
    display: 'Username',
    isFiltered: true,
    width: 250,
    // isRequired: true,
  }),
  strCol({
    ident: 'password',
    display: 'Password',
    isFiltered: true,
    // isRequired: false,
    width: 250,
  }),
  modifierCol,
  modifiedDateCol,
]

const title = 'Web Service Access'

const WEEWebServiceAccess = _ => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <table
      style={{ width: '100%', borderSpacing: '5px', borderCollapse: 'inherit' }}
    >
      <tbody>
        <tr>
          <TableTD>Service Name :</TableTD>
          <td style={{ minWidth: '150px' }}>
            <Input
              key="serviceName"
              value={insertData.serviceName}
              placeholder="Service Name"
              onChange={e =>
                setInsertData({ ...insertData, serviceName: e.target.value })
              }
              maxLength={50}
            />
          </td>
          <TableTD>URL :</TableTD>
          <td style={{ minWidth: '150px' }} colSpan={5}>
            <Input
              key="url"
              value={insertData.url}
              placeholder="URL"
              name="url"
              onChange={e =>
                setInsertData({ ...insertData, url: e.target.value })
              }
            />
          </td>
        </tr>
        <tr>
          <TableTD>Username :</TableTD>
          <td>
            <Input
              key="userName"
              value={insertData.userName}
              placeholder="Username"
              name="userName"
              onChange={e =>
                setInsertData({ ...insertData, userName: e.target.value })
              }
            />
          </td>
          <TableTD>Password :</TableTD>
          <td>
            <Input
              key="password"
              value={insertData.password}
              placeholder="Password"
              onChange={e =>
                setInsertData({
                  ...insertData,
                  password: e.target.value,
                })
              }
            />
          </td>
          <td>
            <Button type="primary" onClick={() => onAdd(true)}>
              Add
            </Button>
          </td>
          <td>
            <Button
              style={{ marginLeft: '20px' }}
              type="primary"
              onClick={() => onAdd(false)}
            >
              Add & Hide
            </Button>
          </td>
          <td>
            <Button
              style={{ marginLeft: '20px' }}
              type="danger"
              onClick={onCancel}
            >
              Cancel
            </Button>
          </td>
        </tr>
      </tbody>
    </table>
  )

  return (
    <CommonScreen
      title={title}
      header={headers}
      saveTask={saveWSAccessInfoWEE}
      retrieveTask={getWSAccessInfoWEE}
      deleteTask={deleteWSAccessInfoWEE}
      altBy={d => d.serviceName}
      autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={100}
      onInsertEvent={b => setInsertEvent(b)}
      sortOptions={[
        // { ident: 'utility', display: 'Utility', sortOrder: 'asc' },
        { ident: 'serviceName', display: 'Service Name', sortOrder: 'asc' },
      ]}
    />
  )
}

export default WEEWebServiceAccess
